/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2022 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

import ServiceRegistry from "bundle/util/ServiceRegistry";
import AdobeIcon from "icons/AdobeIcon";

const getLegalDialogData = showLegalDialog => {
    const appStore = ServiceRegistry.getService("AppStore");
    let legalData = {};
    if (appStore.configStore.getConfig().showLegalNotice) {
        const legalDialogLabelID = appStore.enableModernViewer
            ? "LEGAL_NOTICES_MODERN_VIEWER" : "LEGAL_NOTICES";
        legalData = {
            title: appStore.intl
                .formatMessage({ id: legalDialogLabelID }),
            clickHandler: showLegalDialog,
        };
        if (appStore.enableModernViewer) {
            /* In case of modern viewer, it is mandatory to pass icon,
                inorder to show legal dialog */
            legalData.icon = AdobeIcon;
        }
    }
    return legalData;
};

export default { getLegalDialogData };
